import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { YearOfSuitDto, StateDto, LorpDto, CurrencyDto, ClaimTypeDto, CommunitiesDto, SecurityClassificationDto, 
  DocumentTypeDto, DocumentTypeCodeDto, FiscalFileLocationDto, LgaDto, CounselTypeDto, SuitProgressDto, AdrDto, SuitCounselDto, LandTitleRegisterDto } from '@cradua/data';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { fadeInAnimation } from 'libs/shared/src/lib/_animations/fade-in.animation';
import { AdrFacade } from '../../states/+adr/adr.facade';
import { DocumentFacade } from "../../../../../generic-document/src/lib/document-states/document.facade";

@Component({
  selector: 'cradua-viewprogress-container',
  templateUrl: './viewprogress-container.component.html',
  styleUrls: ['./viewprogress-container.component.scss'],
  animations: [fadeInAnimation],
})
export class ViewprogressContainerComponent implements OnInit {

  isLoadingYearOfSuits$: Observable<any>;
  isLoadingStates$: Observable<any>;
  isLoadingLorps$: Observable<any>;
  isLoadingCurrencys$: Observable<any>;
  isLoadingClaimTypes$: Observable<any>;
  isLoadingCommunitiess$: Observable<any>;
  isLoadingSecurityClassifications$: Observable<any>;
  isLoadingDocumentTypes$: Observable<any>;
  isLoadingDocumentTypeCodes$: Observable<any>;
  isLoadingFiscalFileLocations$: Observable<any>;
  isLoadingLgas$: Observable<any>;
  isLoadingCounselTypes$: Observable<any>;
  isLoadingAdrProgress$: Observable<any>;
  isLoadingAdr$: Observable<any>;

  isLoadingDocument$: Observable<any>;
  completed$: Observable<boolean>;
  progress$: Observable<number>;
  error$: Observable<string>;
  isInProgress$: Observable<boolean>;
  isReady$: Observable<boolean>;
  hasFailed$: Observable<boolean>;
  hasStarted$: Observable<boolean>;
 

  yearofsuits$: Observable<YearOfSuitDto[]>;
  states$: Observable<StateDto[]>;
  lorps$: Observable<LorpDto[]>;
  currencys$: Observable<CurrencyDto[]>;
  claimtypes$: Observable<ClaimTypeDto[]>;
  communitiess$: Observable<CommunitiesDto[]>;
  securityclassifications$: Observable<SecurityClassificationDto[]>;
  documenttypes$: Observable<DocumentTypeDto[]>;
  documenttypecodes$: Observable<DocumentTypeCodeDto[]>;
  filelocations$: Observable<FiscalFileLocationDto[]>;
  lgas$: Observable<LgaDto[]>;
  counseltypes$: Observable<CounselTypeDto[]>;
  suitcounsels$: Observable<SuitCounselDto[]>;
  adrProgresss$: Observable<SuitProgressDto[]>;
  adrs$: Observable<AdrDto[]>;
  task = "list";
  fetchDocument$: Observable<AdrDto[]>;
  selectedSuitProgresss: AdrDto;


  constructor(
    public dialog: MatDialog, private gatewwayFacade: GatewayFacade, private adrFacade: AdrFacade,
    private router: Router, private notificationService: NotificationService, private documentFacade: DocumentFacade,
    ) {}

  ngOnInit() {
    this.isLoadingYearOfSuits$ = this.gatewwayFacade.isLoadingGateway("YearOfSuit");
    this.isLoadingStates$ = this.gatewwayFacade.isLoadingGateway("State");
    this.isLoadingLorps$ = this.gatewwayFacade.isLoadingGateway("Lorp");
    this.isLoadingCurrencys$ = this.gatewwayFacade.isLoadingGateway("Currency");
    this.isLoadingClaimTypes$ = this.gatewwayFacade.isLoadingGateway("ClaimType");
    this.isLoadingCommunitiess$ = this.gatewwayFacade.isLoadingGateway("Communities");
    this.isLoadingSecurityClassifications$ = this.gatewwayFacade.isLoadingGateway("SecurityClassification");
    this.isLoadingDocumentTypes$ = this.gatewwayFacade.isLoadingGateway("DocumentType");
    this.isLoadingDocumentTypeCodes$ = this.gatewwayFacade.isLoadingGateway("DocumentTypeCode");
    this.isLoadingFiscalFileLocations$ = this.gatewwayFacade.isLoadingGateway("FiscalFileLocation");
    this.isLoadingLgas$ = this.gatewwayFacade.isLoadingGateway("Lga");
    this.isLoadingCounselTypes$ = this.gatewwayFacade.isLoadingGateway("CounselType");
    this.isLoadingAdrProgress$ = this.gatewwayFacade.isLoadingGateway("SuitProgress");

    this.completed$ = this.documentFacade.completed();
    this.progress$ = this.documentFacade.progress();
    this.error$ = this.documentFacade.error();
    this.isInProgress$ = this.documentFacade.isInProgress();
    this.isReady$ = this.documentFacade.isReady();
    this.hasFailed$ = this.documentFacade.hasFailed();
    this.hasStarted$ = this.documentFacade.started();

    this.yearofsuits$ = this.gatewwayFacade.loadGateway("YearOfSuit");
    this.states$ = this.gatewwayFacade.loadGateway("State");
    this.lorps$ = this.gatewwayFacade.loadGateway("Lorp");
    this.currencys$ = this.gatewwayFacade.loadGateway("Currency");
    this.claimtypes$ = this.gatewwayFacade.loadGateway("ClaimType");
    this.communitiess$ = this.gatewwayFacade.loadGateway("Communities");
    this.securityclassifications$ = this.gatewwayFacade.loadGateway("SecurityClassification");
    this.documenttypes$ = this.gatewwayFacade.loadGateway("DocumentType");
    this.documenttypecodes$ = this.gatewwayFacade.loadGateway("DocumentTypeCode");
    this.filelocations$ = this.gatewwayFacade.loadGateway("FiscalFileLocation");
    this.fetchDocument$ = this.documentFacade.loadDocument;
    this.lgas$ = this.gatewwayFacade.loadGateway("Lga");
    this.counseltypes$ = this.gatewwayFacade.loadGateway("CounselType");
    this.suitcounsels$ = this.gatewwayFacade.loadGateway("SuitCounsel");
    this.adrProgresss$ = this.gatewwayFacade.loadGateway("SuitProgress");
    this.adrs$ = this.adrFacade.loadRegister$;

  }

  onSearch(value) {
    console.log('search ', value)
    const query = {
      name: value,
    };
    this.isLoadingAdr$ = this.adrFacade.isLoadingAdr(query);
  }

  onTask(task: string) {
    console.log('task ', task);
    this.task = task;
    this.selectedSuitProgresss = null;
    this.adrs$ = this.adrFacade.clearAdr;
    this.fetchDocument$ = this.documentFacade.loadClearDocument();
  }

  onEmitView(value: AdrDto) {

    if(value != null) {
      this.isLoadingDocument$ = this.documentFacade.isLoadingDocumentById(value.id);
      this.isLoadingAdr$ = this.adrFacade.isLoadingAdrById(value.id);
    }
    this.task = 'create';
  }

  uploadFile(value: any) {
    const {FilePath, ...doc} = value;
    if(typeof FilePath === 'string') {
      doc['FilePath'] = FilePath;
    }
    doc['type'] = 'landTitleRegister';
    this.documentFacade.uploadSingleDocumentWithFile(doc, FilePath);
  }

  resetUpload(value) {
    this.documentFacade.resetUpload();
  }

  cancelUpload(value) {
    this.documentFacade.cancelUpload();
  }

  onSaveManyDoc(value: LandTitleRegisterDto[]) {
    this.isLoadingDocument$ = this.documentFacade.addAcquisitionDocument(value);
  }

  onSubmit(formData) {
    this.task = 'create';

    const {id, ...newFormData} = formData;
    formData.id ?
    this.gatewwayFacade.update('SuitProgress', formData, ['id']):
    this.gatewwayFacade.add('SuitProgress', newFormData);
  }

}
